import kompack from './kompack'

export default [...kompack]
